import $ from 'jquery'

export function initSlideshow(options = {}) {
  const $slideshow = options.slideshow || $('.slideshow');

  if ($slideshow.length) {
    $slideshow.on('init', function(slick){
      setImageClass(slick)
    })

    $slideshow.slick({
      dots: true,
      infinite: true,
      adaptiveHeight: true,
      focusOnChange: true,
    });
  }
}

function setImageClass(slick) {
  const $paragraphs = $(slick.target).find('.slick-slide:not(.slick-cloned)').find('p');

  $paragraphs.each((index, paragraph) => {
    if ($.trim($(paragraph).text()).length && $(paragraph).has("img").length) {
      $(paragraph).addClass("with-image-and-text")
    }
  })
}
